var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-banner"},[(_vm.list.length)?_c('el-carousel',{attrs:{"autoplay":false}},_vm._l((_vm.list),function(item){return _c('el-carousel-item',{key:item.id},[_c('div',{staticClass:"banner-img"},[_c('img',{attrs:{"src":item.imgUrl,"alt":item.imgUrl}})])])}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }